import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { TCategoryClickEventParams } from './_types';

export const categoryClickEvent = (params: TCategoryClickEventParams) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.MAIN_PAGE_SECTION_CLICK,
    params,
  });
};
